import { useCheckFeatureFlag } from './useFeatureFlags';
import { FeatureFlags } from './useFeatureFlags/types';

function useIsOrgNavBar2025Enabled() {
  const checkFeatureFlag = useCheckFeatureFlag();

  return checkFeatureFlag(FeatureFlags.ORG_NAV_BAR_2025);
}

export default useIsOrgNavBar2025Enabled;
